var map = {
	"./symbol_0.png": "811f",
	"./symbol_1.png": "7da0",
	"./symbol_10.png": "a66a",
	"./symbol_11.png": "b1ea",
	"./symbol_2.png": "8468",
	"./symbol_3.png": "a2eb",
	"./symbol_4.png": "cc70",
	"./symbol_5.png": "d18c",
	"./symbol_6.png": "d1f3",
	"./symbol_7.png": "9af4",
	"./symbol_8.png": "94c9",
	"./symbol_9.png": "af8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7230";